module.exports = __webpack_public_path__ + "static/media/Devante.bf21c925.jfif";